import React from 'react';
import './../index.css';

const iconModules = require.context('../assets/icons/technologies', false, /\.(png|jpe?g|svg)$/);
const images = iconModules.keys().map((path) => {
  const moduleValue = iconModules(path);
  return moduleValue.default || moduleValue;
});

const Gallery = () => {
  return (
    <div className='flex flex-row items-center'>
      {images.map((img, index) => (
        <span className='w-24 mx-3' key={index}>
          <img src={img} alt={`technology-icon-${index}`} />
        </span>
      ))}
    </div>
  );
};

export default Gallery;